import React from 'react';

import "./image-window.css";

const ImageWindow = ({ imageLink, sourceName, sourceLink }) => {

    const renderLinkToSource = (sourceName, sourceLink) => {
        if (!sourceName || !sourceLink) {
            return;
        }

        return (<a className="window-source" href={sourceLink} target = "_blank" rel="noreferrer">Source: { sourceName }</a>)
    };

    return (
        <>
        <div className="window-wrapper">
        <div className="window">
            <div className="window-options">
                <span className="circle red"></span>
                <span className="circle yellow"></span> 
                <span className="circle green"></span> 
            </div>
            <img src={imageLink} alt=""/>
            
        </div>
            {renderLinkToSource(sourceName, sourceLink)}
        </div>
        
        </>
    );
}

export default ImageWindow;